import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { PapiSession } from '@wix/da-papi-types';
import { flagsFromSession } from '../helpers';
import { FlagsObject } from '../types';

export const initFlags = createAction(
  `${actionKey}.INIT_FLAGS`,
  (session: PapiSession | undefined) => ({
    flags: flagsFromSession(session?.features),
  })
);

export const setFlags = createAction(`${actionKey}.SET_FLAGS`, (flags: FlagsObject) => ({ flags }));
